import { useNavigate } from 'react-router-dom';

import RequestEnterMetadataComponent from '../../components/CreateRequest/components/enter-metadata.component';
import GoBackButton from '../../components/GoBackButton';
import SEO from '../../components/SEO';
import { generateSEOMetadata, dynamicPages } from '../../utils/seo';

const CreateRequest = () => {
  const navigate = useNavigate();

  // Generate SEO metadata for create request page
  const seoMetadata = generateSEOMetadata.dynamicPage(
    dynamicPages['request/create'].name,
    dynamicPages['request/create'].url,
    dynamicPages['request/create'].description
  );

  return (
    <div>
      <SEO {...seoMetadata} />
      <div className={'w-full flex flex-col items-center bg-white'}>
        <div className="sticky top-[68px] md:top-[70px] px-[17.5px] pt-5 md:pt-10 pb-6 w-full text-center z-10 bg-white">
          <GoBackButton onClick={() => navigate('/article/manage?tab=requests')} />
          <h1 className="text-2xl md:text-[32px] font-[800] mb-1">Submit New Request</h1>
          <p className="!text-02-dim-gray">
            Send a request of the content you need to <br />
            your community
          </p>
        </div>
        <div className="px-[17.5px] w-full md:mb-0 mb-[50px] mt-8">
          <RequestEnterMetadataComponent />
        </div>
      </div>
    </div>
  );
};

export default CreateRequest;
